export default {
  CONVOY: 'Convoy',
  MEYERTRANSPORT: 'Meyer Transport LLC',
  FOXLOGISTICS: 'Fox Logistics',
  AZ_TRUCKING: 'A&Z Trucking',
  BRIDGE_LOGISTICS: 'Bridge Logistics Inc',
};
